export default import.meta.url

import receiver from"workerpool/receiver"

self.onmessage = message => receiver(message.data)